import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import IconInfo from 'components/icons/IconInfoNew';
import IconTick from 'components/icons/iconTick';
import CtaButton from 'components/essentials/Cta/CtaButton';
import FlyoutContainer from 'components/consumer/FlyoutContainer';
import { colorGrayLight1 } from 'styles/layout/colors';
import useScreen from 'hooks/useScreen';
import PDPPriceSection from '../PDPPriceSection';
const PDPExtraOptionSelectorUI = t0 => {
  const $ = _c(42);
  const {
    loading,
    isAdded,
    priceObj,
    onAdd,
    onRemove
  } = t0;
  const {
    isDesktop
  } = useScreen();
  const [flyOutTop, setFlyOutTop] = useState(0);
  const [isFlyOutVisible, setIsFlyOutVisible] = useState(false);
  const containerRef = useRef(null);
  let t1;
  if ($[0] !== isDesktop) {
    t1 = isVisible => {
      if (isDesktop) {
        setIsFlyOutVisible(isVisible);
        setFlyOutTop(containerRef.current?.getBoundingClientRect().top || 0);
      }
    };
    $[0] = isDesktop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleFlyOut = t1;
  let t2;
  if ($[2] !== flyOutTop || $[3] !== isFlyOutVisible) {
    t2 = isFlyOutVisible && <FlyoutContainer top={flyOutTop} headerBgColor="grey" mobileContentNoPadding={true} title="How the extra cushion works" imageUrl="https://joybird2.imgix.net/public_img/extra-cushion.png" onClose={() => setIsFlyOutVisible(false)} isOpen={isFlyOutVisible} content={<><div className="text-xs">Remove the ottoman and replace your chaise cushion with your extra cushion to instantly turn your sectional into a sofa!{" "}</div><br /><div className="text-xs">Do the opposite and, you guessed it, you’ve got a sectional.</div></>} />;
    $[2] = flyOutTop;
    $[3] = isFlyOutVisible;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span>Add Extra Cushion (Optional)</span>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] !== toggleFlyOut) {
    t4 = () => toggleFlyOut(true);
    t5 = () => toggleFlyOut(false);
    $[6] = toggleFlyOut;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsFlyOutVisible(true);
    t7 = <IconInfo height={14} width={14} color={colorGrayLight1} />;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5) {
    t8 = <div className="text-gray text-base font-bold">{t3}<button type="button" className="relative cursor-pointer p-2 [background:none] border-0" onMouseEnter={t4} onMouseLeave={t5} onClick={t6}>{t7}</button></div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t10;
  let t9;
  if ($[14] !== toggleFlyOut) {
    t9 = () => toggleFlyOut(true);
    t10 = () => toggleFlyOut(false);
    $[14] = toggleFlyOut;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <JBImage width={200} src="https://joybird2.imgix.net/public_img/extra-cushion.png" />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t9) {
    t12 = <div className="flex-[0.43] cursor-pointer bg-white lg:flex-[0.4] [&_img]:h-full [&_img]:object-contain" onMouseOver={t9} onMouseOut={t10}>{t11}</div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="text-sm font-bold">Extra Cushion</div>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== priceObj) {
    t14 = <div><PDPPriceSection priceObj={priceObj} variant="PDPExtraOptionSelector" /></div>;
    $[22] = priceObj;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="text-xs mt-2 mx-0 mb-3 text-gray-light1">Get an extra cushion to switch between sectional and sofa.</div>;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  const t16 = isAdded ? "brand" : "brand-light";
  const t17 = isAdded ? onRemove : onAdd;
  let t18;
  if ($[25] !== isAdded) {
    t18 = isAdded ? <span className="items-center flex"><IconTick height="16" width="16" /><span>Added</span></span> : "+ Add";
    $[25] = isAdded;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== loading || $[28] !== t16 || $[29] !== t17 || $[30] !== t18) {
    t19 = <CtaButton block={true} type="submit" color={t16} styling="solid-button" data-xc="add-upsell-button" className="w-auto min-w-[80px] p-[.3rem] md:px-3 md:py-[.3rem] hover:bg-brand-light" disabled={loading} onClick={t17} isLoading={loading}>{t18}</CtaButton>;
    $[27] = loading;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t14 || $[33] !== t19) {
    t20 = <div className="p-4 flex-[0.57] lg:flex-[0.6]">{t13}{t14}{t15}{t19}</div>;
    $[32] = t14;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t12 || $[36] !== t20) {
    t21 = <div className="flex mt-2 border border-solid border-gray-light6 rounded">{t12}{t20}</div>;
    $[35] = t12;
    $[36] = t20;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t2 || $[39] !== t21 || $[40] !== t8) {
    t22 = <div className="mt-8 mx-0 mb-0 lg:z-[2] lg:relative" ref={containerRef}>{t2}{t8}{t21}</div>;
    $[38] = t2;
    $[39] = t21;
    $[40] = t8;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  return t22;
};
PDPExtraOptionSelectorUI.propTypes = {
  loading: PropTypes.bool,
  isAdded: PropTypes.bool,
  priceObj: PropTypes.object,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func
};
export default PDPExtraOptionSelectorUI;